<template>
    <div v-show="largeModal" class="modal-window">
        <div class="modal-content">
        <!-- <b-modal title="হোল্ডিং" no-close-on-backdrop hide-footer size="xl"  v-model="largeModal" > -->
            <div style="border-bottom:1px solid #bbc3ca" class="container">
                <div class="row">
                    <div class="col-md-6">
                        <span class="pull-left"><b>নতুন হোল্ডিং</b></span>
                    </div>
                    <div class="col-md-6">
                        <span @click="close()" style="cursor:pointer" class="pull-right"><b><i class="fa fa-times"></i></b></span>
                    </div>
                </div>
                <div style="width:100%;height:10px;"></div>
            </div>
            <div class="container pt-2">
                <form @submit.prevent="AddHolding">
                    <div class="container custom_modal_body">
                <div  class="form-group row">
                    <label  class="col-sm-2 col-form-label">মোবাইল নম্বর</label>
                    <div class="col-sm-3">
                        <input type="text" disabled v-validate="'required|numeric'" v-model="user.mobile_number" class="form-control" name="phone" placeholder="মোবাইল নম্বর">
                    </div>
                    <div class="col-sm-2"></div>
                    <label  class="col-sm-2 col-form-label">এন.আই.ডি নম্বর</label>
                    <div class="col-sm-3">
                        <input type="text" disabled v-validate="'required|numeric'" v-model="user.nid" class="form-control" name="nid" placeholder="এন.আই.ডি নম্বর">
                    </div>
                </div>
                <div  class="form-group row">
                    <label  class="col-sm-2 col-form-label">নাম</label>
                    <div class="col-sm-3">
                        <input name="Name" disabled v-validate="'required'"   type="text"  v-model="user.name" class="form-control"  placeholder="নাম">
                    </div>
                    <div class="col-sm-2"></div>
                    <label class="col-sm-2 col-form-label">জন্ম তারিখ</label>
                    <div class="col-sm-3">
                        <input type="date" disabled v-model="user.birthday" class="form-control"  placeholder="জন্ম তারিখ">
                    </div>
                </div>
                <div v-if="$user.type==1"  class="form-group row">
                    <label for="bn_name" class="col-sm-2 col-form-label">হোল্ডিং নম্বর (বাংলা) <span style="color:red">*</span></label>
                    <div class="col-sm-3">
                        <input name="bn_name" v-validate="'required'" v-model="holdingForm.bn_name" class="form-control"  >
                        <p  v-show="errors.has('bn_name')" style="color:red">* {{ errors.first('bn_name') }}</p>
                    </div>
                    <div class="col-sm-2"></div>
                    <label for="en_name" class="col-sm-2 col-form-label">হোল্ডিং নম্বর (ইংরেজিতে) <span style="color:red">*</span></label>
                    <div class="col-sm-3">
                        <input name="en_name"  v-validate="'required'" v-model="holdingForm.en_name" class="form-control"  >
                        <p  v-show="errors.has('en_name')" style="color:red">* {{ errors.first('en_name') }}</p>
                    </div>
                </div>
                <div  class="form-group row">
                    <label for="home_name" class="col-sm-2 col-form-label">বাসার নাম <span style="color:red">*</span></label>
                    <div class="col-sm-3">
                        <input name="home_name"  v-validate="'required'" v-model="holdingForm.home_name" class="form-control"  >
                        <p  v-show="errors.has('home_name')" style="color:red">* {{ errors.first('home_name') }}</p>
                    </div>
                    <div class="col-sm-2"></div>
                    <label for="address" class="col-sm-2 col-form-label"> ঠিকানা <span style="color:red">*</span></label>
                    <div class="col-sm-3">
                        <input name="address"  v-validate="'required'" v-model="holdingForm.address" class="form-control" >
                        <p  v-show="errors.has('address')" style="color:red">* {{ errors.first('address') }}</p>
                    </div>
                </div>
                <div  class="form-group row">
                    <label for="owner_name" class="col-sm-2 col-form-label">মালিকের নাম <span style="color:red">*</span></label>
                    <div class="col-sm-3">
                        <input name="owner_name"  v-validate="'required'" v-model="holdingForm.owner_name" class="form-control"  >
                        <p  v-show="errors.has('owner_name')" style="color:red">* {{ errors.first('owner_name') }}</p>
                    </div>
                    <div class="col-sm-2"></div>
                    <label for="word_no" class="col-sm-2 col-form-label ">ওয়ার্ড <span style="color:red">*</span></label>
                    <div class="col-sm-3">
                        <div class="input-group">
                            <select v-validate="'required'" name="word_no" v-model="holdingForm.word_no"  class="form-control" >
                                <option value="">ওয়ার্ড সিলেক্ট করুন</option>
                                <option v-for="(ward,key) in wards" :key="key" :value="ward.id" >{{ ward.ward_name_bng}}</option>
                            </select>
                             <p  v-show="errors.has('word_no')" style="color:red">* {{ errors.first('word_no') }}</p>
                        </div>
                    </div>
                </div>
                <div v-if="$user.type==1" class="form-group row">
                    <label for="avatar" class="col-sm-2 col-form-label">অনুমোদন ডকুমেন্ট <span style="color:red">*</span></label>
                    <div class="col-sm-3">
                        <input
                            name="document"
                            v-validate="'required|size:2048'"
                            type="file"
                            class="file-input"
                            v-on:change="onAvatarChange"
                        />
                        <p v-show="errors.has('document')"  style="color:red">* {{ errors.first('document') }}</p>
                    </div>
                    <div class="col-sm-2"></div>
                    <label for="approve" class="col-sm-2 col-form-label ">স্ট্যাটাস</label>
                    <b-form-group>
                        <div class="col-sm-3">
                            <b-form-radio v-model="selected"  name="status" value="1">অনুমোদিত </b-form-radio>
                            <b-form-radio v-model="selected"  name="status" value="0">অননুমোদিত </b-form-radio>
                        </div>
                    </b-form-group>
                </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12">
                        <input type="submit" value="submit" v-if="!addLoader"  class="btn btn-primary pull-right">
                        <button v-if="!addLoader" @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                        <button v-if="addLoader" class="btn btn-primary pull-right" type="button" disabled>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Submitting...
                        </button>
                    </div>
                </div>
            
                </form>
            </div>
        <!-- </b-modal> -->
        </div>
    </div>
</template>

<script>

    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);
    import { mapGetters } from "vuex"
    import axios from 'axios'
    export default {
        data(){
            return{
                largeModal:false,
                addLoader: false,
                selected:1,
                check:false,
                file:'',
                user:{
                    id:'',
                    name:'',
                    nid:'',
                    mobile_number:'',
                    birthday:'',
                },
                holdingForm:{
                    bn_name:'',
                    en_name:'',
                    word_no:'',
                    address:'',
                    home_name:'',
                    owner_name:'',
                    status:'',
                    avatar:''

                }
            }
        },

        computed:{
            ...mapGetters(['wards','modal'])
        },
        mounted(){
            this.wardLists()
        },
        methods:{
            onAvatarChange(e) {
                var fileReader = new FileReader()
                fileReader.readAsDataURL(e.target.files[0])
                fileReader.onload = e => {
                    this.holdingForm.avatar = e.target.result
                }
                this.check = false
                // this.url = URL.createObjectURL(e.target.files[0])
            },
            openModal(data){
                this.largeModal = true
                this.user = data

            },
            close(){
                this.largeModal = false
            },
            // AddHolding(){
            //     if(this.$user.type!=1){
            //         this.holdingForm.avatar =true
            //     }
            //     this.check = true
            //     this.$validator.validateAll().then(results => {
            //         if (results && this.holdingForm.avatar){
            //             this.addLoader = true
            //             this.holdingForm.user_id = this.user.id
            //             this.holdingForm.status = this.selected
            //             // this.$store.dispatch('ADD_HOLDING',)
            //                 axios.post('/holding',this.holdingForm)
            //                 .then(v=>{
            //                     this.$store.commit('AFTER_ADD_HOLDER',v.data)
            //                     this.addLoader = false
            //                     this.holdingForm.bn_name =""
            //                     this.holdingForm.en_name=""
            //                     this.holdingForm.owner_name=""
            //                     this.holdingForm.home_name=""
            //                     this.holdingForm.word_no =""
            //                     this.holdingForm.status = ''
            //                     this.largeModal = false

            //                 })
            //                 .catch(error=>{
            //                     // this.addLoader=false;
            //                     this.servererrors = error.response.data.errors;
            //                 });
            //         }
            //     })

            // },
            AddHolding(){
                this.holdingForm.user_id = this.user.id
                this.holdingForm.status = this.selected
                // this.$store.dispatch('ADD_HOLDING',this.holdingForm)
                this.$validator.validateAll().then(results => {
                    if (results){
                        this.addLoader = true
                         axios.post('/holding',this.holdingForm)
                        .then(response=>{
                            this.holdingForm.bn_name =""
                            this.holdingForm.en_name=""
                            this.holdingForm.owner_name=""
                            this.holdingForm.home_name=""
                            this.holdingForm.word_no =""
                            this.holdingForm.status = ''
                            
                            this.$emit('pushHolding',response.data)
                            this.largeModal = false
                            this.addLoader = false
                            this.$iziToast.success({position:'topRight',title:'Ok',message:"সফল হয়েছেন"})
                        })
                        .catch(error=>{
                            this.addLoader=false;
                            this.servererrors = error.response.data.errors;
                        });
                        
                    }
                })
               
            },
            wardLists(){
                this.$store.dispatch('WARD_LIST',{invoice_type:''})
            }
        }

    }
</script>
<style scoped>
.modal-window{
        position: fixed;
        z-index: 1144;
        padding-top: 50px;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .modal-content{
        position: fixed;
        z-index: 11144;
        padding-top: 15px;
        left: 15%;
        top: 10%;
        width:70%;
        /* height:80%; */
        overflow: auto;
        background-color:#fff;
    }
    .pt-2{
        padding-top:20px !important;
    }
</style>